import { Router } from '@angular/router';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { environment } from '@environment/environment';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
	constructor(private injector: Injector) {}
	handleError(error) {
		if (!environment.production) {
			this.injector.get(Router);
			console.error(error);
		}
	}
}
